import React, {useEffect, useState} from 'react';
import '../../styles/style.css';
import news1 from "../../assets/images/news1.png";
import news2 from "../../assets/images/news2.png";
import news3 from "../../assets/images/news3.png";
import ArrowRightIcon from '../../assets/images/arrow-right.png';
import axios from "axios";
import BASE from "../../config";
import {Link} from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3, // Adjust based on your design
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
            }
        }
    ]
};


const getFirstImageFromContent = (html) => {
    if (typeof html !== "string") return null;
    const match = html.match(/<img[^>]+src="([^">]+)"/);
    return match ? match[1] : null;
};




const Latest_News = () => {

    const [posts, setPosts] = useState([]);
    useEffect(() => {
        axios
            .get(BASE.LIVE_SITE_URL+'/news/wp-json/wp/v2/posts?_embed')
            .then((res) => {
                // WP may return HTML/error objects if the news API route is missing
                setPosts(Array.isArray(res.data) ? res.data : []);
            })
            .catch((error) => {
                console.error('Error fetching posts:', error);
                setPosts([]);
            });
    }, []);

    if (!posts.length) {
        return null;
    }

    return(
        <div className="Latest_News_Section">
            <div className="container">
                <h1>Latest News</h1>
                <div className="row">
                    <Slider {...settings}>
                        {posts.map((news, index) => {
                            const imageUrl = getFirstImageFromContent(news.content?.rendered);
                            return (
                                <div className="col-md-4" key={news.id ?? index}>
                                    <div className="Latest_News_Box latest-new-box-1">
                                        <Link className="latest-image" target="_blank" to={news.link}>
                                        {imageUrl && <img src={imageUrl} alt="News" />}
                                        </Link>
                                        <div className="latest-news-inner-data">
                                        <Link className="latest-news-title" target="_blank" to={news.link}>
                                        <h3 dangerouslySetInnerHTML={{ __html: news.title?.rendered || "" }} />
                                        </Link>
                                        <p dangerouslySetInnerHTML={{ __html: news.excerpt?.rendered || "" }} />
                                        <Link target="_blank" to={news.link}>
                                            Read More{" "}
                                            <img
                                                src={ArrowRightIcon}
                                                alt="Arrow Right"
                                                style={{
                                                    width: "12px",
                                                    height: "12px",
                                                    marginLeft: "8px",
                                                    marginTop: "7px",
                                                }}
                                            />
                                        </Link>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </Slider>

                </div>
            </div>
        </div>
    )
}



export default Latest_News;